import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Card, Btn, Input } from "@/components/erp/ui";
import { Plus, Trash2 } from "lucide-react";

const Rows = ({ rows, setRows, group, tid }) => (
  <div className="space-y-1">
    {rows.map((p, i) => (
      <div key={i} className="flex gap-1 items-center" data-testid={`${tid}-row-${i}`}>
        {group && <Input data-testid={`${tid}-group-${i}`} value={p.group_label} placeholder="Kelompok" onChange={(e) => setRows(rows.map((x, j) => (j === i ? { ...x, group_label: e.target.value } : x)))} className="!w-48" />}
        <Input data-testid={`${tid}-label-${i}`} value={p.label} placeholder="Nama titik pengecekan" onChange={(e) => setRows(rows.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} />
        <button type="button" data-testid={`${tid}-del-${i}`} onClick={() => setRows(rows.filter((_, j) => j !== i))}><Trash2 className="w-4 h-4 text-rose-500" /></button>
      </div>))}
    <button type="button" data-testid={`${tid}-add`} onClick={() => setRows([...rows, { label: "", group_label: rows[rows.length - 1]?.group_label || "Umum", key: "" }])} className="text-xs text-sky-700 inline-flex items-center gap-1"><Plus className="w-3.5 h-3.5" />Tambah titik</button>
  </div>
);

// Admin utama: atur titik pengecekan buku kesehatan, poin lite maintenance & jadwalnya
export const HealthCfgSettings = () => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/machines/health/config").then(({ data }) => setC(data)).catch(() => {}); }, []);
  if (!c) return null;
  const save = async () => { try { const { data } = await api.put("/machines/health/config", c); setC(data); toast.success("Pengecekan mesin disimpan"); } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); } };
  return (
    <Card className="p-4 mt-4" data-testid="health-cfg">
      <h3 className="font-semibold text-sm mb-2">Buku kesehatan mesin — titik pengecekan</h3>
      <div className="flex flex-wrap gap-3 text-xs mb-3">
        <label>Pengecekan lengkap tiap <Input type="number" data-testid="health-full-days" value={c.full_days} onChange={(e) => setC({ ...c, full_days: +e.target.value })} className="!w-20 inline-block" /> hari (notifikasi ke teknisi)</label>
        <label>Lite maintenance tiap <Input type="number" data-testid="health-lite-days" value={c.lite_days} onChange={(e) => setC({ ...c, lite_days: +e.target.value })} className="!w-20 inline-block" /> hari (notifikasi ke operator, tiap Senin)</label>
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <div><div className="text-xs font-semibold mb-1">Pengecekan lengkap ({c.points.length} titik)</div><Rows rows={c.points} setRows={(v) => setC({ ...c, points: v })} group tid="hp" /></div>
        <div><div className="text-xs font-semibold mb-1">Lite maintenance mingguan — operator ({c.lite.length} poin)</div><Rows rows={c.lite} setRows={(v) => setC({ ...c, lite: v })} tid="lp" /></div>
      </div>
      <Btn className="mt-3" data-testid="health-cfg-save" onClick={save}>Simpan</Btn>
    </Card>
  );
};
